import { useState } from 'react';
// Ask box temporarily hidden — see commented-out JSX below.
// import { Button, Input } from '@fluentui/react-components';
// import { askChat, ApiError } from '../api';

interface Message {
  role: 'user' | 'assistant';
  text: string;
}

/**
 * Completion line + free-form ask box. QCBot's CHAT OUTPUT STYLE keeps replies short by
 * default; full summaries/reports only appear when the user explicitly asks for them here.
 */
export function ChatPanel({ runId, issueCount }: { runId: string; issueCount: number }) {
  const [messages, setMessages] = useState<Message[]>([{ role: 'assistant', text: `${issueCount} issue(s) found.` }]);
  // const [question, setQuestion] = useState('');
  // const [asking, setAsking] = useState(false);

  // async function send() {
  //   if (!question.trim()) return;
  //   const q = question.trim();
  //   setMessages((prev) => [...prev, { role: 'user', text: q }]);
  //   setQuestion('');
  //   setAsking(true);
  //   try {
  //     const answer = await askChat(runId, q);
  //     setMessages((prev) => [...prev, { role: 'assistant', text: answer }]);
  //   } catch (e) {
  //     // The team being archived isn't transient — say so instead of suggesting a retry.
  //     const text = e instanceof ApiError && e.code === 'team_unavailable' ? e.message : 'Sorry, that request failed. Try again.';
  //     setMessages((prev) => [...prev, { role: 'assistant', text }]);
  //   } finally {
  //     setAsking(false);
  //   }
  // }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 220, overflowY: 'auto' }}>
        {messages.map((m, i) => (
          <div key={i} style={{ whiteSpace: 'pre-wrap', fontSize: 13, color: m.role === 'user' ? '#0f6cbd' : '#222' }}>
            {m.text}
          </div>
        ))}
      </div>
      {/* Ask input/button temporarily hidden
      <div style={{ display: 'flex', gap: 6 }}>
        <Input
          style={{ flex: 1, minWidth: 0 }}
          value={question}
          placeholder='e.g. "summary", "report", "fix I-014"'
          onChange={(_, d) => setQuestion(d.value)}
          onKeyDown={(e) => e.key === 'Enter' && send()}
        />
        <Button appearance="primary" disabled={asking} onClick={send} style={{ flexShrink: 0 }}>
          Ask
        </Button>
      </div>
      */}
    </div>
  );
}
